<template>
	<div class = "shop-div">
		<div class = "shops">
			<div class = "shop-title">附近门店</div>
			
			<!-- 搜索提示 -->
			<van-empty v-if="!shopList || shopList.length <= 0" image="search" :description="shopListCtx" />
			<div  class = "shop-list" v-for = "(item,index) in shopList" :key="index" >
				<van-divider v-show = "index != 0" />
				<div @click = "intoShop(item)">
					<div class = "shop-name">{{item.shopName}}</div>
					<div>
						<van-row>
							<van-col span="18">{{item.shopLocation}}</van-col>
							<van-col offset="2" span="4">{{item.distance|distanceFilter}}</van-col>
						</van-row>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { Divider,Col, Row,Empty,Notify} from 'vant';
	import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
	export default {
		name:'ComShopList',
		components:{
			[Divider.name]: Divider,
			[Col.name]: Col,
			[Row.name]: Row,
			[Empty.name]: Empty,
			[Notify.name]: Notify
		},
		created() {
			this.listenScroll()
		},
		props:{
			shopList:{
				Array,default:[]
			},
			shopListCtx:{
				String,default:"加载中"
			}
		},
		data(){
			return {
				
			}
		},
		methods:{
			...mapMutations(['sSetShopLocation','clearGoodsList']),
			intoShop(shop){
				let now = new Date()
				let nowHour = parseInt(now.getHours())
				let nowMin = parseInt(now.getMinutes())
				
				
				// console.log(nowHour,nowMin)
				if(nowHour>=21){
					this.$router.push("unSell");
					return
				}
				if(nowHour < 8){
					this.$router.push("unSell");
					return
				}
				// if(nowHour<8 || (nowHour == 9 && nowMin<5)){
				// 	this.$router.push("unSell");
				// 	return
				// }
				let lonAndLat = shop.lat+','+shop.lng;
				this.sSetShopLocation({
					shopName:shop.shopName,
					shopAddress:shop.shopLocation,
					lonAndLat:lonAndLat,
					storeId:shop.storeId
				});
				// console.log(shop);
				// 进入门店后自动清除购物车
				// this.clearGoodsList()
				this.$router.push("goods");
			},
			listenScroll() {
				let _this = this;
				this.$nextTick(() => {
					//获取节点
					let container = this.$el.querySelector(".shops");
					let offsetHeight = container.offsetHeight;
					//绑定事件
					container.addEventListener('scroll', function() {
						let scrollTop = container.scrollTop;
						let scrollHeight = container.scrollHeight;
						if (offsetHeight + scrollTop >= scrollHeight ) {
							_this.$emit('refresh')
						}
					})
				});
			}
			
		},
		filters: {
		  distanceFilter: function (value) {
		    if (!value) {
				return ''
			}
			if(value<1000){
				value = parseInt(value);
				return value+"m";
			}else{
				value = value/1000
			    value = value.toFixed(1);
				return value+"km";
			}
		    
		  }
		}
	}
</script>

<style scoped>
	/**  shopList start   */
	.shop-div {
		padding: 0 13px;
		height: calc(100% - 250px);
	}
	.shops {
		background-color: #ffffff;
		padding: 10px 13px;
		height: 100%;
		overflow-y: auto;
		
	}
	.shop-title {
		font-size: 18px;
		color: #999999;
		font-weight: 500;
		margin-bottom: 5px;
	}
	.shop-name {
		font-size: 14px;
		line-height: 30px;
		color: #3a3a3a;
		font-weight: 550;
	}
	.shop-list .van-col {
		color: #969696;
		line-height: 17px;
	}
	.shop-list .van-divider--hairline {
		margin: 12px 0;
		border-color: #dadada;
	}
	
	.shop-list .van-col--4 {
		text-align:right;
	}
	/**  shopList end   */
</style>
